import { createRouter } from '@tanstack/react-router';
import { organizationPages, organizationRoute } from './organization-routes';
import {
  acceptInvitationRoute,
  forgotRoute,
  handoffRoute,
  hostCallbackRoute,
  hostStartRoute,
  loginRoute,
  logoutRoute,
  pilotRoute,
  resetRoute,
} from './public-routes';
import { appRoute, deniedRoute, platformRoute, rootRoute } from './root-routes';
import { settingsPages, settingsRoute } from './settings-routes';

/** The route tree: public pages, then the authenticated shell with the console home and the
 *  organization screens (each group in its own file). */
const routeTree = rootRoute.addChildren([
  loginRoute,
  forgotRoute,
  resetRoute,
  acceptInvitationRoute,
  hostStartRoute,
  hostCallbackRoute,
  handoffRoute,
  logoutRoute,
  pilotRoute,
  appRoute.addChildren([
    platformRoute,
    deniedRoute,
    organizationRoute.addChildren([
      ...organizationPages,
      settingsRoute.addChildren([...settingsPages]),
    ]),
  ]),
]);

export const router = createRouter({
  routeTree,
  defaultPreload: 'intent',
  scrollRestoration: true,
  // The window does not scroll: the main area of the shell does (shell.css).
  scrollToTopSelectors: ['main.area'],
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
